<template>
  <div class="hamburger">
    <div @click="closeHandler" id="nav-icon3" v-bind:class="{ open: open }">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Hamburger',
  data () {
    return {
    }
  },
  props: ['open'],
  computed: {
  },
  methods: {
    closeHandler () {
      this.$emit('toggleClose')
    }
  }
}
</script>
<style lang="scss" scoped>
.hamburger {
  z-index: 99;
  width: 54px;
  height: 50px;
  position: absolute;
  box-sizing: border-box;
  padding: 19px 10px 10px 16px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
/* Icon 1 */
#nav-icon3 {
  width: 32px;
  height: 32px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
}
#nav-icon3 span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: #ffff76;
  border-radius: 0px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
 }
.open#nav-icon3 span {
  background-color: #ffff76;
}
/* Icon 3 */
#nav-icon3 span:nth-child(1) {
  top: 0px;
}
#nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
  top: 8px;
}
#nav-icon3 span:nth-child(4) {
  top: 16px;
}
#nav-icon3.open span:nth-child(1) {
  top: 16px;
  width: 0%;
  left: 50%;
  background-color: #ffff76;
}
#nav-icon3.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #ffff76;
}
#nav-icon3.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: #ffff76;
}
#nav-icon3.open span:nth-child(4) {
  top: 16px;
  width: 0%;
  left: 50%;
  background-color: #ffff76;
}
.hamburger.white {
  span {
    background-color: #fff !important;
  }
}
</style>
